import { handleActions } from 'redux-actions';

export default handleActions(
	{
		GET_MEMBERS_PENDING: state => ({
			...state,
			loading: true,
		}),

		GET_MEMBERS_FULFILLED: (state, action) => ({
			...state,
			staffs: action.payload.staffs,
			loading: false,
		}),

		CLEAN_MEMBERS: state => ({
			...state,
			staffs: {},
		}),

		UPDATE_MEMBER_DATA_FULFILLED: (state, action) => ({
			...state,
			...action.payload,
		}),

		SEND_MOBILE_VERIFY_FULFILLED: (state, action) => ({
			...state,
			...action.payload,
		}),

		VERIFY_MOBILE_CODE_FULFILLED: (state, action) => ({
			...state,
			...action.payload,
		}),

		EMPTY_ERROR: (state, action) => ({
			...state,
			emptyError: action.payload.empty,
		}),

		CHECK_IDENTITY_FULFILLED: (state, action) => ({
			...state,
			...action.payload,
		}),

		CHANGE_IDENTITY: (state, action) => ({
			...state,
			identityDuplicate: action.payload.identityDuplicate,
		}),
	},
	{
		loading: false,
		staffs: {},

		type: '',
		unlockTime: '',
		avatar: '',
		name: '',
		nickname: '',
		gender: '',
		birth: '',
		identityType: '',
		identity: '',
		city: '',
		district: '',
		zipCode: '',
		address: '',
		mobile: '',
		email: '',
		id: '',
		sync: '',
		credit: 0,

		googleBind: '',
		facebookBind: '',

		emailVerify: '',
		mobileVerify: '',

		mobileVerifyFail: false,

		emptyError: false,

		identityDuplicate: false,
	},
);



// WEBPACK FOOTER //
// ./src/reducers/members.js